import React from 'react'
import ImageUpload from 'storfox-image-upload'
import PropTypes from 'prop-types'

import { useImageUpload } from '~/components/ImageUpload'

function BundleImageUploadField ({ name, accept }) {
  const { upload } = useImageUpload()

  const onUpload = (data, onProgress) =>
    upload(data, onProgress)
      .then(response => {
        const imagePath = response['ids'][0]
        const isDefault = length === 0
        return { imagePath, isDefault }
      })

  return (
    <ImageUpload onUpload={onUpload} name={name} accept={accept} />
  )
}

BundleImageUploadField.defaultProps = {
  name: 'images'
}

BundleImageUploadField.propTypes = {
  name: PropTypes.string,
  accept: PropTypes.string
}

export default BundleImageUploadField
